<template>
  <USelectMenu
    v-model="currentValue"
    :items="items"
    label-key="title"
    by="idDiscountModel"
    :placeholder="$t('discount.select')"
    :filter-fields="['title']"
    v-bind="$attrs"
  >
    <template #default="{ modelValue: selected }">
      <div v-if="selected" class="flex items-center justify-between w-full h-full pr-2 text-sm text-gray-800 dark:text-gray-100">
        <div class="text-left">
          <p class="text-gray-800 dark:text-gray-100">
            {{ selected.title }}
          </p>
          <p class="text-gray-600 dark:text-gray-300">
            {{ selected.isAmountTypeFixed ? $currency.format(selected.price) : selected.price + '%' }}
          </p>
        </div>

        <o-chip v-if="selected.locked" variant="danger" size="xs">
          {{ $t('general.locked') }}
        </o-chip>
      </div>
    </template>

    <template #item="{ item }">
      <div v-if="item" class="w-full flex items-center justify-between">
        <div>
          <p class="text-gray-800 dark:text-gray-100">
            {{ item.title }}
          </p>
          <p class="text-gray-600 dark:text-gray-300">
            <template v-if="item && item.price">
              {{ item.isAmountTypeFixed ? $currency.format(item.price) : item.price + '%' }}
            </template>
            <template v-else>
              -
            </template>
          </p>
        </div>

        <o-chip v-if="item.locked" variant="danger" size="xs">
          {{ $t('general.locked') }}
        </o-chip>
      </div>
    </template>
  </USelectMenu>
</template>

<script setup lang="ts">
import { computed, onMounted } from 'vue'

import { useDiscountModelStore } from '~/stores/useDiscountModelStore'

interface Props {
  modelValue?: any
  filter?: Function | null
  fieldClass?: string
  placeholder?: string
}

const props = withDefaults(defineProps<Props>(), {
  modelValue: null,
  filter: null,
  fieldClass: 'w-full text-sm',
  placeholder: undefined,
})

const emit = defineEmits<{
  (e: 'update:modelValue', value: any): void
}>()

const discountModelStore = useDiscountModelStore()

const currentValue = computed({
  get () {
    return props.modelValue
  },
  set (value) {
    emit('update:modelValue', value)
  },
})

const discounts = computed(() => discountModelStore.all)

const items = computed(() => {
  let list = discounts.value

  if (props.filter) {
    list = list.filter(props.filter as any)
  }

  return [...list].sort((a: any, b: any) => a.listOrder - b.listOrder)
})

onMounted(() => {
  discountModelStore.sync()
})
</script>
